import type { RouteObject } from "react-router";
import PricingPage from "./ui/pages/PricingPage";
import ComparisonPage from "./ui/pages/ComparisonPage";
import BillingPage from "./ui/pages/BillingPage";

export const subscriptionRoutes: RouteObject[] = [
    { path: "/subscription", element: <PricingPage /> },
    { path: "/subscription/compare", element: <ComparisonPage /> },
    // The account's own subscription, as opposed to the public comparison.
    // Also where Stripe returns the browser after Checkout.
    { path: "/subscription/billing", element: <BillingPage /> },
];
